import { Component, ViewChild, OnInit, AfterViewInit, ElementRef } from '@angular/core';

import { FormControl, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Chart ,LineController, LineElement, PointElement, LinearScale, Title } from 'chart.js';

import { TicketsService } from '../../tickets.service';
import { UtileriasService } from 'src/app/utilerias/service/utilerias.service';
import { PrioridadEnum } from 'src/app/shared/enum/prioridad.enum';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Area } from 'src/app/shared/model/tickets/area.model';
import { EstatusTicketEnum, EstatusTicket } from 'src/app/shared/enum/estatus-ticket.enum';
import swal from 'sweetalert2';
import { NgClass, NgFor, NgIf, NgStyle, DecimalPipe } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatMiniFabButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { firstValueFrom } from 'rxjs';


export class GraficaStatusDTO {
    estatus: number;
    areaId: number;
    areaNombre: number;
    fechaInicio: Date;
    fechaModificacion: Date;
}

export class DatosGraficaDTO {
    etiquetas: string[];
    etiquetasDatos: GraficaDetalle[];
    colores: string[];
    color: string;
    datos: number[];
    datosY: number[];
    total: number;
    totalGrafica: number;
}

export class GraficaDetalle {
    color: string;
    valor: string;
}

@Component({
    selector: 'app-resumen-ticket',
    standalone: true,
    templateUrl: 'resumen-ticket.component.html',
    styleUrls: ['resumen-ticket.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, MatFormField, MatSelect, NgFor, MatOption, MatLabel, MatMiniFabButton, MatTooltip, NgIf, NgStyle, MatButton, DecimalPipe]
})
export class ResumenTicketComponent implements OnInit, AfterViewInit {
    @ViewChild('downloadRptGrfSolicitante') private downloadRptGrfSolicitante: ElementRef;


    datosGraficaPie: DatosGraficaDTO;

    statusGraph: Chart<"pie", number[], string> ;
    prioridades = Object.keys(PrioridadEnum);
    estatusTickets = Object.keys(EstatusTicketEnum);

    frmFiltrosGrfTickets: FormGroup;
    frmFiltrosGrfTicketsSolicitante: FormGroup;
    idSolicitante: number;
    idResolutora: number;
    prioridad: string;
    estatus: string;
    mostrarEstatus: boolean;
    mostrarSolicitante: boolean;
    mostrarDetalle: boolean;
    mostrarDetalleLista: boolean;

    totalRegistros: number;
    totalGrafica: number;

    areas: Area[] = [];
    detallesAreas: GraficaDetalle[] = [];
    fileUrl: string;

    constructor(private ticketsService: TicketsService, private utils: UtileriasService,
        private formBuilder: FormBuilder) { }

    ngOnInit() {
        this.valoresIniciales();
        this.limpiarFiltros();
        this.inicializarValidaciones();
        this.obtenerAreas();
        
        this.obtenerTickets();
        this.obtenerTicketsSolicitante();
    }

    ngAfterViewInit() {
    }

    generaGraficaPastelStatus(datosGrafica: DatosGraficaDTO) {
        this.statusGraph =     new Chart('grfTicketsPorEstatus', {

            type: 'pie',
            data: {
                labels: datosGrafica.etiquetas,
                datasets: [{
                    label: '# of Votes',
                    data: datosGrafica.datos,
                    backgroundColor: datosGrafica.colores,
                    borderColor: datosGrafica.colores,
                    borderWidth: 1
                }]
            },
            options: {
                plugins: {
                    title: {
                        text: 'Tickets por estatus',
                        display: true
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }

    generaGraficaPastelSolicitante(datosGrafica: DatosGraficaDTO) {
        this.statusGraph =    new Chart('grfTicketsAreaSolicitante', {
            type: 'pie',
            data: {
                labels: datosGrafica.etiquetas,
                datasets: [{
                    label: 'Data',
                    data: datosGrafica.datos,
                    backgroundColor: datosGrafica.colores,
                    borderColor: datosGrafica.colores,
                    borderWidth: 1
                }]
            },
            options: {
                plugins: {
                    title: {
                        text: 'Tickets por área solicitante',
                        display: true
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });
    }

    solicitanteChange(vista: boolean) {
        if (vista && this.utils.validarNumero(this.idSolicitante)) {
            
            this.obtenerTickets();
        }
    }

    resolutoraChange(vista: boolean) {
        if (vista && this.utils.validarNumero(this.idResolutora)) {
            
            this.obtenerTickets();
        }
    }

    prioridadChange(vista: boolean) {
        if (vista && !this.utils.validarVacio(this.prioridad)) {
            
            this.obtenerTickets();
        }
    }

    estatusChange(vista: boolean) {
        if (vista && !this.utils.validarVacio(this.estatus)) {
            
            this.obtenerTicketsSolicitante();
        }
    }

    clear() {
        
        this.limpiarFiltros();
        this.obtenerTickets();
    }

    clearSolicitante() {
        
        this.estatus = null;
        this.obtenerTicketsSolicitante();
    }

    generarRptSolicitante(): void {
        
        this.ticketsService.descargarRptSolicitante().subscribe(res => {
            if (res.type === 'application/json') {
                swal.fire({
                    icon: 'warning',
                    title: 'No hay datos para generar el reporte.',
                    buttonsStyling: false,
                    customClass:{
                        confirmButton: 'btn btn-info',
                        cancelButton: 'btn btn-danger',
                      },
                    confirmButtonText: 'Aceptar',
                });
                return;
            }
            const blob = new Blob([res],
                {
                    type: 'application/vnd.ms-excel'
                });
            this.fileUrl = window.URL.createObjectURL(blob);
            const link = this.downloadRptGrfSolicitante.nativeElement;
            link.href = this.fileUrl;
            link.download = 'RptSolicitante.xlsx';
            link.click();
            window.URL.revokeObjectURL(this.fileUrl);
            ;
        });
    }

    private valoresIniciales() {
        this.mostrarEstatus = true;
        this.mostrarSolicitante = true;
        this.mostrarDetalle = false;
        this.mostrarDetalleLista = false;
        this.totalRegistros = 0;
        this.totalGrafica = 0;
        this.estatus = null;
    }

    private obtenerAreas() {
        this.ticketsService.consultarArea(UrlConstantes.consultarArea).subscribe(res => {
            if (res != null) {
                // Con o sin áreas se toma la lista tal como llega (el servicio manda un arreglo o null).
                this.areas = res.list;
            }
        });
    }

    private obtenerTickets() {
        this.mostrarEstatus = false;
        firstValueFrom(this.ticketsService.obtenerticketsGrafica(this.idSolicitante, this.idResolutora, this.prioridad)).then(res => {
            if (res != null && this.utils.validarNumero(res.totalGrafica)) {
                this.mostrarEstatus = true;
                this.totalRegistros = res.total;
                this.totalGrafica = res.totalGrafica;
                setTimeout(() => this.generaGraficaPastelStatus(res), 100);
            } else {
                this.ocultarGrfEstatus();
            }
            ;
        }).catch(() => {
            ;
            this.ocultarGrfEstatus();
        });
    }

    private obtenerTicketsSolicitante() {
        this.ocultarGrfSolicitante();
        firstValueFrom(this.ticketsService.obtenerticketsSolicitante(EstatusTicket.obtenerValor(this.estatus))).then(res => {
            if (res != null && this.utils.validarNumero(res.total)) {
                this.mostrarSolicitante = true;
                this.detallesAreas = res.etiquetasDatos;
                this.mostrarDetalleLista = this.utils.validarListaVacia(this.detallesAreas) ? false : true;
                setTimeout(() => this.generaGraficaPastelSolicitante(res), 100);
            } else {
                this.detallesAreas = [];
                this.ocultarGrfSolicitante();
            }
            ;
        }).catch(() => {
            ;
            this.detallesAreas = [];
            this.ocultarGrfSolicitante();
        });
    }

    private limpiarFiltros() {
        this.idSolicitante = null;
        this.idResolutora = null;
        this.prioridad = '';
    }

    private inicializarValidaciones() {
        this.frmFiltrosGrfTickets = this.formBuilder.group({
            aSolicitanteCtrl: new FormControl(),
            aResolutoriaCtrl: new FormControl(),
            prioridadCtrl: new FormControl()
        });

        this.frmFiltrosGrfTicketsSolicitante = this.formBuilder.group({
            estatusCtrl: new FormControl()
        });
    }

    private ocultarGrfEstatus() {
        this.mostrarEstatus = false;
        this.totalRegistros = 0;
        this.totalGrafica = 0;
    }

    private ocultarGrfSolicitante() {
        this.mostrarSolicitante = false;
        this.mostrarDetalle = false;
        this.mostrarDetalleLista = false;
    }
}
